<template>
  <div>
    <page-header />
    <page-banners v-if="!isObitsPage && !isObit" />
    <page-intro v-if="isHomePage" />
    <page-services v-if="isHomePage" />
    <page-content />
    <obituaries v-if="isObitsPage" />
    <obituary v-if="isObit" />
    <latest-obituaries v-if="isHomePage" />

    <contact-form />
    <iframe title="Map" allowfullscreen frameborder="0" height="450"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9575.718470650185!2d-1.258892!3d53.129409!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x21f941989e86b5cf!2sA%20Wass%20Funeral%20Directors%20Ltd!5e0!3m2!1sen!2suk!4v1570005773015!5m2!1sen!2suk"
      style="border:0;margin-bottom:-1rem;" v-if="isContactPage" width="100%"></iframe>
    <page-footer />

    <div class='cookie-banner' v-if="showBanner">
      <p>
        This website collects cookies to deliver better user experience
      </p>
      <button class='accept' @click="accept">Accept</button>
      <button class='reject' @click="reject">Reject</button>
    </div>
    <div class='cookie-settings' v-if="!showBanner">
      <button class='settings' @click="reset">Cookie Settings</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import api from "@/services/api"

import ContactForm from "@/components/ContactForm.vue"
import PageBanners from "@/components/Banners.vue"
import PageHeader from "@/components/Header.vue"
import PageContent from "@/components/Content.vue"
import PageIntro from "@/components/Intro.vue"
import PageServices from "@/components/Services.vue"
import PageFooter from "@/components/Footer.vue"
import LatestObituaries from "@/components/LatestObituaries.vue"
import Obituaries from "@/components/Obituaries.vue"
import Obituary from "@/components/Obituary.vue"

export default {
  name: "page",
  components: {
    ContactForm,
    PageBanners,
    PageHeader,
    PageContent,
    PageIntro,
    PageServices,
    PageFooter,
    LatestObituaries,
    Obituaries,
    Obituary
  },
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    this.checkConsentStatus();
  },
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage", "isWhenSomeoneDiesPage", "isContactPage", "isObitsPage", "isObit"])
  },
  metaInfo() {
    return {
      title: this.page.title,
      meta: [{ name: "description", content: this.page.meta_desc }, { name: "keywords", content: this.page.meta_keywords }]
    }
  },
  created: function () {
    var route = this.$route
    var url = route.params.url
    var promises = []
    var store = this.$store
    var state = this.$store.state

    if (!url) store.commit("setPage", {})

    if (route.name == "404") this.page = { main_text: "Sorry, this page cannot be found!" }

    if (route.name == "page-by-url") promises.push(api.getPageByURL(url))
    if (route.name == "root") promises.push(api.getHomePage())

    if (route.name == "obit") {
      promises.push(
        api.getPageByItemID(route.params.itemid).then(obit => {
          if (!obit || !obit.ItemID) this.page = { main_text: "Sorry, this page cannot be found!" }
          obit.posts = []
          if (obit.candles && obit.candles.length) {
            var i = 0
            obit.candles.forEach(candle => {
              candle._type = "candle"
              candle._index = i
              i++
            })
            obit.posts = obit.posts.concat(obit.candles)
          }
          if (obit.messages && obit.messages.length) {
            obit.messages.forEach(message => {
              message._type = "message"
            })
            obit.posts = obit.posts.concat(obit.messages)
          }

          obit.posts.sort((a, b) => (a._timestamp > b._timestamp ? 1 : -1))
          return Promise.resolve(obit)
        })
      )
      promises.push(
        api.getPageByItemID(state.obitID).then(page => {
          if (!page || !page.ItemID) this.page = { main_text: "Sorry, this page cannot be found!" }
          return Promise.resolve(page)
        })
      )
    }

    Promise.all(promises).then(vals => {
      var returnedpage = vals[0]
      store.commit("setPage", returnedpage)

      if (!returnedpage || !returnedpage.ItemID) store.commit("setPage", { main_text: "Sorry, this page cannot be found!" })

      if (!this.isWhenSomeoneDiesPage && (!this.page.banners || !this.page.banners.length))
        api.getPageByItemID(state.whensomeonediesID, "banners").then(whensomeonedies => {
          this.$set(this.page, "banners", whensomeonedies.banners)
          this.$nextTick().then(() => {
            window.$(".cycle-slideshow").cycle({ slides: ".slide", pager: ".banner-pager" })
          })
        })
      else
        this.$nextTick().then(() => {
          window.$(".cycle-slideshow").cycle({ slides: ".slide", pager: ".banner-pager" })
        })
    })

    store.dispatch("getSettings")
    store.dispatch("getMainPages")
    store.dispatch("getObits")
  },
  methods: {
    checkConsentStatus() {
      const consentStatus = localStorage.getItem('cookieConsent');

      if (consentStatus === 'granted' || consentStatus === 'denied') {
        this.showBanner = false;

        gtag('consent', 'update', {
          'ad_storage': consentStatus === 'granted' ? 'granted' : 'denied',
          'analytics_storage': consentStatus === 'granted' ? 'granted' : 'denied'
        });
      } else {
        this.showBanner = true;
      }
    },
    accept() {
      localStorage.setItem('cookieConsent', 'granted');
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      });
      this.showBanner = false;
    },
    reject() {
      localStorage.setItem('cookieConsent', 'denied');
      gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
      });
      this.showBanner = false;
    },
    reset() {
      localStorage.setItem('cookieConsent', 'denied');
      gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
      });
      this.showBanner = true;
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 1.5rem 3rem;
  width: 100%;
  gap: 2rem;
  display: flex;
  align-items: center;
  background-color: #231f20;
  border: #666 1px solid;
}

.cookie-settings {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
}

.settings {
  background-color: white;
  border: #666 1px solid;
  color: '#666';
  cursor: pointer;
  font-size: 1.5rem;
  padding: 1rem;
}

.cookie-banner>*:first-child {
  flex: 1;
}

.cookie-banner>* {
  flex: 0;
}

.cookie-banner p {
  margin: 0;
  color: #fff;
  font-size: 1.5rem;
}

.accept,
.reject {
  background-color: #bb9765;
  border: none;
  color: white;
  border-radius: 2px;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 1rem;
}

.reject {
  background-color: #9e7f54;
}
</style>